import React from "react";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import {LOCO_HEADER_COLOR} from "../GameStyleUI";
import LocoPopupCard from "../LocoCards/LocoPopupCard";
import TrainCarPackCard from "../LocoCards/TrainCarPackCard";
import GameData from "../../../gameplay/model/GameData";
import CurrencyCard from "../GeneralCards/CurrencyCard";
import GameController from "../../../gameplay/controllers/GameController";
import car_train_icon from "../../../images/gameplay_ui/icons/car_train_icon.svg";
import agent from "../../../agent";
import "./PathDetailsWindow.css";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import DragElement from "./DragElement";
import DropContainer from "./DropContainer";
import UtilsFunctions from "../../../utils/UtilsFunctions";

class PathDetailsWindow extends React.Component {
  constructor() {
    super();

    let trainMasterIndex = UtilsFunctions.getRoleNameIndex("Заместитель по тяге");
    this.isTrainMaster = UtilsFunctions.playerHasRole(trainMasterIndex);
    this.isLateEvening = GameData.CurrentGame.state === 5;
  }

  getLocoCard(loco) {
    if (!loco) return;

    return <LocoPopupCard
      canSetHot={!loco.isBreakDown} teamID={this.props.teamID} parent={this} loco={loco}
      style={{padding: "5px"}} onClick={(val) => {
      console.log(val)
    }}
    />;
  }

  getDragElement(type, el, train, i, content, elID) {
    let isNotBreakDown = true;
    if (el === "loco") {
      isNotBreakDown = false;

      for (let el of train.locomotives) {
        let loco = GameData.CurrentGame.getLocoById(el);

        if (loco.isBreakDown) {
          isNotBreakDown = true;
          break;
        }
      }

      if (!isNotBreakDown) {
        isNotBreakDown = GameController.calculateAvailablePathThroughput({
          path: this.props.path,
          teamID: this.props.teamID,
        }) <= 0;
      }
    }
    let isHot = el === "loco" ? GameData.CurrentGame.getLocoById(elID).isHot : false;

    return <DragElement
      type={type} canDrag={this.isLateEvening && this.isTrainMaster && (isNotBreakDown || !isHot)}
      name={`train-${train.id}-${el}-${i}`} train={train} elID={elID}
      el={el} content={content}
    />
  }

  getShort(train) {
    const locoSlots = 3;
    let locoGridStyle = {
      paddingTop: "20px",
      display: "grid",
      gridTemplateColumns: "110px 110px 110px 153px 153px",
      gridColumnGap: "10px"
    }
    let locoSlotStyle = {
      height: "160px",
      background: "rgba(3, 3, 3, 0.1)",
      borderRadius: "5px",
    }
    let trainSlots = [];

    for (let i = 0; i < 5; i++) {
      if (i < locoSlots) {
        let theCard = this.getLocoCard(GameData.CurrentGame.getLocoById(train.locomotives[i]));

        trainSlots.push(<div style={locoSlotStyle} key={i}>
          {train.locomotives.length > i ?
            this.getDragElement("fromTrain", "loco", train, i, theCard, train.locomotives[i]) :
            <DropContainer accepts="fromGround-loco" noML={true} onDrop={(item) => {
              this.moveLocoToTrain(train, item.elID);
            }}/>}
        </div>);
      } else {
        let theCard = <TrainCarPackCard
          trainCarsPack={train.carTrainPacks[i - locoSlots]}
          style={{padding: "5px"}}/>;

        trainSlots.push(<div style={locoSlotStyle} key={i}>
          {train.carTrainPacks.length > (i - locoSlots) ?
            this.getDragElement("fromTrain", "pack", train, i, theCard, train.carTrainPacks[i - locoSlots])
            : <DropContainer accepts="fromGround-pack" noML={true} onDrop={(item) => {
              this.moveTrainPackToTrain(train, item.elID);
            }}/>}
        </div>);
      }

    }
    return <div style={locoGridStyle} key={"short-train-grid"}>
      {trainSlots}
    </div>
  }

  moveTrainPackToTrain(train, trainCarPackId) {
    let path = this.props.path;
    let trainCarPack = GameData.CurrentGame.getTrainCarById(trainCarPackId);
    let weight = GameController.calculateAvailablePathThroughput({
      path,
      teamID: this.props.teamID,
    }) - trainCarPack.weight;

    // Если для нового вагона не хватит места
    if (weight < 0) {
      alert("Пропускной способности пути не хватает для этого груза");
    } else {
      agent.GamePlay.setTrainCarPackOnTrain(this.props.teamID,
        {
          pathId: path.id,
          trainId: train.id,
          trainCarId: trainCarPackId
        }, (r) => {
          console.log(r)
        });
    }
  }

  async moveTrainPackToGround(train, trainCarPackId) {
    return await agent.GamePlay.setTrainCarPackOnGround(this.props.teamID, {
        pathId: this.props.path.id,
        trainId: train.id,
        trainCarId: trainCarPackId
      }, () => null,
    )
  }

  async moveLocoToGround(train, locoId) {
    if (train.locomotives.length === 1 && train.carTrainPacks.length > 0) {
      alert("В поезде был только один локомотив, груз переносится вместе с ним!");

      for await (let car of train.carTrainPacks) {
        await this.moveTrainPackToGround(train, car);
      }
    }

    agent.GamePlay.setLocoOnGround(this.props.teamID, {
      pathId: this.props.path.id,
      trainId: train.id,
      locoId: locoId
    }, (r) => console.log(r))
  }

  moveLocoToTrain(train, locoId) {
    // В бекенде не поменяли название параметра, должен быть locoId, но
    // остался trainCarId
    // TODO – потом поменять на нормальное
    if (this.props.path) {
      agent.GamePlay.setLocoOnTrain(this.props.teamID, {
        pathId: this.props.path.id,
        trainId: train.id,
        trainCarId: locoId
      }, (r) => console.log(r))
    }
  }

  getLong(train) {
    const locoSlots = 5;
    let locoGridStyle = {
      paddingTop: "20px",
      display: "grid",
      gridTemplateColumns: "110px 110px 110px 110px 110px 153px 153px 153px 153px 153px",
      gridColumnGap: "10px"
    }
    let locoSlotStyle = {
      height: "159px",
      background: "rgba(3, 3, 3, 0.1)",
      borderRadius: "5px"
    }
    let trainSlots = [];
    for (let i = 0; i < 10; i++) {
      if (i < locoSlots) {
        let theCard = <LocoPopupCard
          parent={this} teamID={this.props.teamID}
          loco={GameData.CurrentGame.getLocoById(train.locomotives[i])}
          style={{padding: "5px"}} canSetHot={true}
        />;

        trainSlots.push(<div style={locoSlotStyle} key={i}>
          {train.locomotives.length > i ?
            this.getDragElement("fromTrain", "loco", train, i, theCard, train.locomotives[i]) :
            <DropContainer accepts="fromGround-loco" noML={true} onDrop={(item) => {
              this.moveLocoToTrain(train, item.elID);
            }}/>}

        </div>);
      } else {
        let theCard = <TrainCarPackCard
          trainCarsPack={train.carTrainPacks[i - locoSlots]} style={{padding: "5px"}}/>;

        trainSlots.push(<div style={locoSlotStyle} key={i}>
          {train.carTrainPacks.length > (i - locoSlots) ?
            this.getDragElement("fromTrain", "pack", train, i, theCard, train.carTrainPacks[i - locoSlots])
            : <DropContainer accepts="fromGround-pack" noML={true} onDrop={(item) => {
              this.moveTrainPackToTrain(train, item.elID);
            }}/>}
        </div>);
      }
    }
    return <div style={locoGridStyle} key={"long-train-grid"}>
      {trainSlots}
    </div>
  }

  createLocoScroll() {
    let path = this.props.path;
    let trains = [];

    for (let j = 0; j < path.currentTrainIDs.length; j++) {
      let train = GameData.CurrentGame.getTrainById(path.currentTrainIDs[j]);
      if (train.trainType === 0) {
        trains.push(this.getShort(train));
      } else {
        trains.push(this.getLong(train));
      }
    }

    return trains;
  }

  createGroundScroll() {
    let path = this.props.path;
    let style = {
      display: "flex",
      flexWrap: "wrap"
    }
    let locoCards = [];
    let trainCarPackCards = [];
    for (let i = 0; i < path.LocoOnGround.length; i++) {
      let theCard = <LocoPopupCard
        parent={this} teamID={this.props.teamID}
        loco={GameData.CurrentGame.getLocoById(path.LocoOnGround[i])}
        style={{padding: "5px"}}
      />;

      locoCards.push(<DragElement
        type="fromGround-loco" canDrag={this.isLateEvening && this.isTrainMaster}
        name={`path-${path.id}-loco-${i}`} el={"loco"}
        content={theCard} elID={path.LocoOnGround[i]}
      />)
    }
    for (let i = 0; i < path.TrainCarPackOnGround.length; i++) {
      let theCard = <TrainCarPackCard
        trainCarsPack={path.TrainCarPackOnGround[i]} style={{padding: "5px"}}/>;

      trainCarPackCards.push(<DragElement
        type="fromGround-pack" el={"pack"}
        canDrag={this.isLateEvening && this.isTrainMaster}
        name={`path-${path.id}-car-${i}`}
        content={theCard} elID={path.TrainCarPackOnGround[i]}
      />)
    }

    return <div style={style}>
      {locoCards}
      {trainCarPackCards}
    </div>
  }

  checkIfCanHide() {
    if (this.isTrainMaster) {
      let path = this.props.path;
      let trains = path.currentTrainIDs.map(el => GameData.CurrentGame.getTrainById(el));

      let validation = GameController.validateEndEvening(GameData.CurrentGame, trains, path);

      if (!validation.status) {
        alert(validation.error);
        return;
      }
    }

    this.props.onHide();
  }

  render() {
    let path = this.props.path;
    let moveStyle = {
      position: "absolute",
      left: this.props.width / 2,
      top: this.props.height / 2 - 50,
      transform: window.innerWidth > 1500 ? "translate(-50%,-50%)" : "translate(-50%, -47%) scale(0.8)"
    }
    let scrollStyle = {
      width: 1431,
      paddingLeft: 10,
      height: "300px",
      overflow: "scroll",
      overflowY: "visible",
      overflowX: "hidden",
    }
    let textStyle = {
      paddingLeft: 20,
      paddingTop: 10,
      fontSize: 14,
      fontWeight: "bold",
      textAlign: "left",
      textTransform: "uppercase"
    }
    let colors = LOCO_HEADER_COLOR[path.locoType];
    let content = [];
    content.push(<div key={'on-train'} style={textStyle}>{"На путях"}</div>)

    content.push(<div key={"loco-scroll-2"} style={scrollStyle}>
      {this.createLocoScroll()}
    </div>);
    content.push(<div key={'separator'} style={{
      marginLeft: 10,
      width: 1431,
      height: 1,
      background: "rgba(3, 3, 3, 0.3)"
    }}/>)
    content.push(<div key={'on-ground'} style={textStyle}>{"В тупике"}</div>)
    content.push(<DropContainer
      key={'ground-scroll'} accepts="fromTrain" style={scrollStyle}
      content={this.createGroundScroll()}
      onDrop={(item) => {
        if (item.el === "loco") {
          this.moveLocoToGround(item.train, item.elID);
        } else {
          this.moveTrainPackToGround(item.train, item.elID);
        }
      }
      }/>);

    let currencyBlocks = [];
    currencyBlocks.push(<CurrencyCard
      key={'currency'}
      title={"Пропускная способность"}
      icon={car_train_icon}
      value={`${GameController.calculateAvailablePathThroughput({
        path,
        teamID: this.props.teamID
      })}`}
      size={20}
      fontSize={14}
      style={{
        marginLeft: "10px"
      }}
    />);

    content = <DndProvider backend={HTML5Backend}>
      {content}
    </DndProvider>

    return <div className="in-game-popup" style={{
      width: this.props.width,
      height: this.props.height,
      background: "rgba(0, 0, 0, 0.5)",
      backdropFilter: "blur(5px)"
    }}>
      <div style={moveStyle}>
        <GameWindowHeader
          width={1451} height={40} colorStart={colors[0]} colorEnd={colors[1]}
          onHide={this.checkIfCanHide.bind(this)} title={`Путь ${path.id}`} isClosable={true}
          currencyBlocks={currencyBlocks}
        />
        <GameWindowBg color={"#F2F2F2"} width={1451} height={700} value={content}/>
      </div>

    </div>;
  }
}

export default PathDetailsWindow;
